export default "__VITE_ASSET__Gi6rerAV__"